import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { SheetData } from '../../../services/auth-service/authService'

import Select, { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';

import {GetProcessNames, SaveCustomerMapping, Fetchusersdata, GetCustomerNames, FetchClientids} from '../../../services/process/process_data/process_data';

import './relationship.css';


const identifier = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },

];

const identifier1 = [
  { value: "2way", label: "2way" },
  { value: "3way", label: "3way" },
  { value: "multi way", label: "multi way" },

];


const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* {shouldBadgeShow &&
          `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
      </div>
    </components.ValueContainer>
  );
};


const CustomerMapping = () => {
  const [relationshipName, setRelationshipName] = useState('');
  const [description, setDescription] = useState('');
  const [process, setProcess] = useState({});
  const [relationshipType, setRelationshipType] = useState({});
  const [targetNames, setSelectedOptions] = useState([]);

  const [selectedprocess1, setSelectedprocess1] = useState([]);
  const [userslistOptions1, setUserslistOptions1] = useState([]);
  const [userslistOptions, setUserslistOptions] = useState([]);

  const [clientidsOptions1, setclientidsOptions1] = useState([]);
  const [clientidsOptions, setclientidsOptions] = useState([]);

  // Create state variable for the Select component's value
  const [selectedSource, setSelectedSource] = useState([]);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
};


const fetchClientids = (data) =>{
    
  let payload = {
    'customer_name': data?.label
      
  }
  console.log('payload', payload)
  var FileUploadCredentials = FetchClientids();

  axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
          response => {
              console.log("Validate Credentials Response client ids!!!", response);
              let table_data = response.data;
              // table_data = table_data['data_out'];
              let names = clientidsOptions1;
              table_data.map((data) => {

                  let obj = {
                  value: data.customer_id,
                  label: data.customer_id,
                  key: data.customer_name
                  }
                  names.push(obj);
              })
              // const uniqueArray = Array.from(new Set(names.map(JSON.stringify)), JSON.parse);
              setclientidsOptions1(names);
              }
      )
      .catch((error) => {
          console.error("Error in POST request:", error);
        });
}

  // Handle the change event for the Select component
  const handleSelectChange = (event, { value }) => {
    setSelectedSource(event);
    let finalkey = '';
    for(let key in event){
      finalkey = key;
    }
    
    let data = event[finalkey];
    console.log('finalkey', finalkey, data);
    fetchClientids(data);

  };

  const handleSelectChange1 = (event, { value }) => {
    setProcess(event);
  };

  const handleSelectChangeclientids = (event, { value }) => {
    setclientidsOptions(event);
  };

  const handleSelectChange2 = (event, { value }) => {
    setRelationshipType(event);
  };

  const handleUserChange = (event, { value }) => {
    setUserslistOptions(event);
  };
  

  const saveCustomerMapping = () =>{
    console.log('payload', userslistOptions, process )
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
        'user_name': userslistOptions[0].label,
        'description': description,
        'process': process.label,
        'relationship_type': relationshipType.label,
        'customer_names': selectedSource,
        'client_ids': clientidsOptions
        
    }
    console.log('payload', payload, userslistOptions, process )
    var FileUploadCredentials = SaveCustomerMapping();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                window.location.reload();
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
          });
  }

  const fetchUsersList = () =>{
    
    let payload = {
      'user_id': userCredentials["user_id"],
        
    }
    console.log('payload', payload)
    var FileUploadCredentials = Fetchusersdata();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                
                let table_data = response.data;
                console.log("users name!!!", table_data);
                // table_data = table_data['data_out'];
                if (Array.isArray(table_data) && table_data.length > 0) {
                  let names = table_data.map(user => ({
                      value: user.user_id,
                      label: user.name
                  }));
      
                  setUserslistOptions1(names);
              } else {
                  console.error("Invalid response structure:", response);
              }
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
          });
  }


//   const fetchsheetdata = () => {
//     let payload = {
//       File_data: 'hi',
//     }

//     var FileUploadCredentials = SheetData();

//     axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
//       .then(
//         response => {
//           console.log("Validate Credentials Response!!!", response);
//           let table_data = response.data;
//           console.log(table_data);
//           let table_data_val = table_data;
//           let names = [{ value: "", label: "Select Source" },]
//           table_data.map((data) => {
//             console.log('data' + data.source_name);

//             let obj = {
//               value: data.source_id,
//               label: data.source_name
//             }
//             names.push(obj);
//           })
//           setSelectedOptions(names);
//         }
//       )
//   };

  
const fetchCustomerNames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"]
    }
    
    var FileUploadCredentials = GetCustomerNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate customer names!!!", response);
                let table_data = response.data;
                // Use a Set to store unique client names
                const uniqueClientNames = new Set();

                // Filter the JSON data based on unique client names
                const filtered = table_data.filter((item) => {
                  if (!uniqueClientNames.has(item.customer_name)) {
                    uniqueClientNames.add(item.customer_id);
                    return true;
                  }
                  return false;
                });
                let names = [];
                filtered.map((data) => {

                    let obj = {
                        value: data.customer_id,
                        label: data.customer_name
                    }
                    names.push(obj);
                })
                // const uniqueArray = Array.from(new Set(names.map(JSON.stringify)), JSON.parse);
                setSelectedOptions(names);
            }
        )
}

  const fetchProcessNames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetProcessNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.process_id,
                        label: data.process_name
                    }
                    names.push(obj);
                })
                setSelectedprocess1(names);
            }
        )
}

useEffect(() => {
  fetchUsersList();
  
  fetchProcessNames();
  fetchCustomerNames();
},[]);


  return (
    <>
      <Grid item style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <div style={{ width: '100%' }}>
          <h2 className=" pt-1 pb-1 text-center" style={{ color: "#4969ab" }}>CUSTOMER MAPPING</h2>
        </div>
      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>User name</label> <br />
              <div>
              <Select
                clearable
                options={userslistOptions1}
                selection
                isMulti
                className="user_input"
                size='mini'
                value={userslistOptions}
                onChange={handleUserChange}
                hideSelectedOptions={false}
                styles={styles}
                components={{ ValueContainer }}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Description</label> <br />
              <div >
                <Input
                  type="text"
                  className="resource_input"
                  
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`processInput`}>Process</label> <br />
              <div >
                <Select
                  clearable
                  options={selectedprocess1}
                  selection
                  className="resource_input"
                  size='mini'
                  value={process}
                  onChange={handleSelectChange1}

                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Relationship Type</label> <br />
              <Select
                clearable
                options={identifier1}
                selection
                className="resource_input"
                size='mini'
                value={relationshipType}
                onChange={handleSelectChange2}
              />
            </div>
          </Grid.Column>
          <Grid.Column></Grid.Column>

        </Grid.Row>

      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <Grid.Row >
      
        <Grid.Column>
          <div className="form-group">
            <label className="label1 mb-1" htmlFor={`sourceInput`}>Customer names</label> <br />
            <Select
              clearable
              options={targetNames}
              selection
              isMulti
              className="resource_input"
              size='mini'
              style={{ backgroundColor: 'white' }}
              onChange={handleSelectChange}
              hideSelectedOptions={false}
              value={selectedSource}
              styles={styles}
              components={{ ValueContainer }}
              isSearchable  ={true}
            />
          </div>
        </Grid.Column>
        <Grid.Column>
          {selectedSource && (
            <table id="customers">
                
                {selectedSource.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
          
          <Grid.Column>
          <div className="form-group">
            <label className="label1 mb-1" htmlFor={`sourceInput`}>Client Ids</label> <br />
            <Select
              clearable
              options={clientidsOptions1}
              selection
              isMulti
              className="resource_input"
              size='mini'
              value={clientidsOptions}
              onChange={handleSelectChangeclientids}
              hideSelectedOptions={false}
              styles={styles}
              components={{ ValueContainer }}
              isSearchable
            />
          </div>
          </Grid.Column>
          <Grid.Column>
            {clientidsOptions && (
            <table id="customers">
                
                {clientidsOptions.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
          </Grid.Column>
          </Grid.Row>
      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row >

          <Grid.Column>
            <button style={{ height: "35px", width: "92px", backgroundColor: "#fff", color: "#ffffff", marginLeft: '2em' }} onClick={saveCustomerMapping}>Save</button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

export default CustomerMapping;